import React, { useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';

const AdminApplicationEdit: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();

  useEffect(() => {
    if (!id) {
      // If no ID is provided, redirect back to admin dashboard
      navigate('/admin/dashboard');
      return;
    }

    // Set the application ID in session storage for the form pages
    sessionStorage.setItem('currentApplicationId', id);
    
    // Set admin context so form pages know this is an admin edit
    sessionStorage.setItem('adminEditMode', 'true');
    
    // Navigate to the first page of the form to get the proper paginated experience
    navigate(`/form/page1`, { replace: true });
  }, [id, navigate]);



  if (!id) {
    return null; // Will redirect in useEffect
  }

  // This component will redirect to /form/page1, so we don't need to render anything
  return null;
};

export default AdminApplicationEdit;
